module.exports = __webpack_public_path__ + "img/stats_mobile_it.15451e0.webp";